import {
  HttpEvent,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { map } from 'rxjs/operators';

export const envelopeInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    map<HttpEvent<unknown>, HttpEvent<unknown>>((event) => {
      if (!(event instanceof HttpResponse)) return event;

      const body: any = event.body;
      const data = body?.data ?? body;

      return event.clone({ body: data });
    })
  );
